module.exports = __webpack_public_path__ + "media/images/401-play-logo-big-white--e114f39c.png";